import {Box} from '@chakra-ui/react'
import CartProductPanel from 'modules/cart/components/CartProductPanel'
import {CartItem} from '../types'
import {useCartItems} from '../hooks/useCartItems'
import {EmptyCartInfo} from 'modules/cart/components'

export const CartItems = ({ data, setData }: any) => {
  const { quantityChangeHandler, deleteProductHandler, loading } = useCartItems(data, setData)
  return (
    <Box>
      {
        data?.cart?.items?.length > 0 ? (data?.cart?.items || [])?.map(item => {
          if (!item?.id) {
            return
          }
          return (
            <CartProductPanel
              _notLast={{
                mb: {
                  base: 4,
                  lg: 6,
                },
              }}
              key={item.id}
              cart={data?.cart}
              cartItem={item as CartItem}
              onDelete={deleteProductHandler}
              setData={setData}
              onChangeQuantity={quantityChangeHandler}
              loading={loading}
            />
          )
        }) : (
            <EmptyCartInfo />
        )
      }
    </Box>
  )
}
